<div class="container">
  <div class="row">
    <div class="staticPages">
      <div data-ng-if="language == 'bg'" *ngIf="selectedLang === 'bg'">
        <div class="agreements">
          За да използвате услугите на сайта, трябва да сте съгласни с Общите
          условията за ползване
        </div>

        <h1>
          Общи условия за ползване на услугата "направи резервация" през сайта
          или мобилното приложение на Zavedenia.bg
        </h1>

        <br />
        <p>
          <b class="bold"
            >I."Направи резервация" е услуга на Zavedenia.bg, при която Вие се
            съгласявате със следните условия:</b
          >
        </p>
        <ul>
          <li>
            Да предоставите коректни данни за контакт - име, телефон, имейл за
            връзка.<br />
            (а) Данните ще бъдат използвани за обратна връзка при
            необходимост;<br />
            (б) при въвеждане на неверни, грешни и непълни данни, Вашата
            резервация няма да бъде валидна;<br />
            (в) Ако вече сте регистриран посетител на Zavedenia.bg няма нужда да
            се регистрирате на ново. С влизането в профила си, вашите данни ще
            бъдат използвани с цел “резервация на заведение” (връзка към Общи
            условия за регистрация на посетител)
          </li>

          <li>
            Вашите данни ще бъдат предадени на заведението (трето лице), за
            което си правите резервация.<br />
            (а) Заведението има право да се свърже с Вас за уточняване на
            детайли, свързани с резервацията;<br />
            (б) Заведението може да Ви потърси за реализиране на обратна връзка,
            след реализиране на резервацията и реално посещение в обекта;<br />
            (в) Заведението може да Ви потърси с цел напомняне за наближаваща
            резервация;
          </li>
        </ul>
        <p><b class="bold">II. Потвърждаване на резервации</b></p>
        <ul>
          <li>
            Вашата резервация е потвърдена, когато изрично получите потвърждение
            под формата на SMS, имейл или телефонно обаждане от заведението.
          </li>
          <li>
            В случай, че желаете да отмените дадена резервация сте длъжен да
            уведомите заведението, или да натиснете линка за отказ на
            резервацията в мейла изпратен до Вас (в случаите, когато има такъв
            линк)
          </li>
          <li>
            В случай, че не сте се явили за направена резервация, може да се
            свържем с Вас за установяване на причините.
          </li>
        </ul>

        <p><b class="bold">III. Обратна връзка </b></p>
        <ul>
          <li>
            Вашето мнение / обратна връзка се изпраща до оторизиран представител
            на заведението и не се публикува в профила на заведението, освен в
            случаите когато от заведението решат да го направят. Целта на
            обратната връзка е да сигнализирате за нередност или изкажете
            благодарност.
          </li>
        </ul>
        <p><b class="bold">IV. Допълнителни разпоредби</b></p>
        <ol>
          <li>
            Терминът "направи резервация" може да се среща и под синонимна форма
            като "резервирай", "резервации". При всички изброени случаи става
            въпрос за ползването на една и съща услуга.
          </li>
          <li>
            "Трето лице" е заведението, за което сте изпратили резервация през
            сайта "http://zavedenia.bg" или мобилното приложение на Zavedenia.bg
          </li>
          <li>
            Екипът на Zavedenia.bg се грижи прилежно за Вашите лични данни,
            според ЗЗЛД и няма право да ги предоставя на други, не свързани
            директно с услугата лица; Както и се задължава да ги съхранява
            надлежно и при Ваше желание да ги унищожи.
          </li>
        </ol>

        <p><b class="bold">V. Промяна на условията и правилата</b></p>
        <ul>
          <li>
            Zavedenia.bg запазва правото си да променя правилата и условията за
            обработка на резервации и данните, получени с тях, направени през
            сайта или мобилното приложение на Zavedenia.bg.
          </li>
          <li>
            Всички промени ще бъдат публикувани на тази страница и всеки
            регистриран потребител ще бъде уведомен.
          </li>
        </ul>

        <br />
        <h1>Пращане на смс-и от името на трето лице</h1>
        <p>
          Собственици (управители) на заведения (фирми) имат право да изпращат
          смс съобщения към свои клиенти, през профила на Zavedenia.bg, като
          клиент на фирма, предлагаща смс пакети. Т.е. Zavedenia.bg изпълнява
          посредническа функция, за да улесни и оптимизира процеса на работа на
          регистрирани в Zavedenia.bg заведения (фирми).
        </p>
        <p>
          Това не е пряка услуга, свързана с основната дейност на Zavedenia.bg и
          Zavedenia.bg не носи отговорност за съхранението, обработката и
          изтриването на данни, необходими за извършване на услугата “пращане на
          смс”. Отговорността е изцяло на собствениците (управители) на
          заведения (фирми).
        </p>
        Предоставената информация от тяхна страна се ограничава до набор
        телефонни номера, без те да са свързани с имена на хора или друга
        информация обект на Европейския регламент за защита на личните данни.
        <br />
        <p>
          Собствениците (управителите) на заведения (фирми) се съгласяват към
          всеки изпратен смс с рекламно съдържание да има опция за отказ от
          страна на клиента, собственик на телефонния номер. Това тяхно право ще
          се осъществява чрез изпращане на обратен смс с текст STOP. След което
          телефонния номер ще бъде премахнат от базата данни с телефонни ноемра
          и клиентът няма да получава повече рекламни съобщения.
        </p>
        <p>
          Zavedenia.bg не носи отговорност при нарушаване на тези изисквания,
          както и другите правни изисквания обект на “Общите Европейски правила
          за защита на личните данни” от страна на собствениците (управители) на
          заведения (фирми).
        </p>
        <br />
        <h1>
          Личните Ви данни в сайтовете на Zavedenia.bg (накратко) <br />
          Защо искаме личните Ви данни?
        </h1>
        <ul>
          <li>
            <b class="bold">Кои данни ни трябват?</b><br />Правенето на
            резервация в заведение е свързано с оставяне на данни като
            <b class="bold">имена, телефон и email</b>. В този смисъл при липса
            на телефон и email, заведението може да не приеме дадена резервация.
            Често този който прави резервация, получава обаждане от заведението
            в случай на необходимост от допълнително уточнение или просто
            проверка с цел предпазване от фалшиво резервирани маси. Вие може да
            оставите само малко име и само телефон.
          </li>
          <li>
            <b class="bold">Достъп на трето лице до Вашите данни</b
            ><br />Данните Ви се предават на съответното заведение, в което
            правите резервация, като в най-общия случай това е служител който
            отговаря за резврвациите.
          </li>
          <li>
            <b class="bold">Срок на съхрание</b><br />Данните за всяка една
            резервация се съхранвяват 2 години
          </li>
        </ul>

        <h2>Какви са правата Ви?</h2>
        <ul>
          <li>
            <b class="bold">Право на достъп</b><br />Може да поискате информация
            дали Ваши данни са били обработвани и дали все още фигурурат в
            базата от данни на нашия сайт
          </li>
          <li>
            <b class="bold">Право на изтриване</b><br />Може да поискате данните
            Ви да бъдат изтрити, като изпратите email на
            personaldata&#64;zavedenia.bg със заглавие "Изтриване"
          </li>
          <li>
            <b class="bold">Право за преносимост на данни</b><br />Може да
            поискате извадка кога сме получили Ваши данни и кога сме ги
            обработили. Това може да направите, като изпратите email на
            personaldata&#64;zavedenia.bg със заглавие "Справка"
          </li>
          <li>
            <b class="bold">Право за входиране на жалби</b><br />Може да
            посетите сайта на Комисията за защита на личните данни на следния
            линк:
            <a href="https://www.cpdp.bg/?p=pages&aid=6"
              >https://www.cpdp.bg/?p=pages&aid=6</a
            >, да изпратите писмо до адрес : гр. София 1592, бул. „Проф. Цветан
            Лазаров” № 2, Комисия за защита на личните данни, или да посетите
            адреса на агенцията гр. София, бул. „Проф. Цветан Лазаров” № 2
          </li>
        </ul>

        <h2>Кои сме ние?</h2>
        <ul>
          <li>
            Всички сайтове под шапката на Zavedenia.BG (zavedenia.com, booky.bg,
            programa.bg и лични сайтове на заведения, които ползват платформата
            за резервации брандирана като Booky.bg) се управляват от
            Заведения.БГ ЕООД, регистрирана в София, с адрес Младост 1, бл.29А,
            вх.3. Често дружеството си партнира с други дружества в сектора и
            имената им могат да се срещат заедно, при предосатвяне на дадена
            услуга.
          </li>
        </ul>

        <h2>Обхват на термина “лични данни”</h2>
        <p>
          Според Регламена на Европейския парламент и на Съвета, засягащ “общите
          правила за защита на личните данни” (GDPR) влизащ в сила на 25 май
          2018 г., обработването, съхранението и изтриването на лични данни
          придобива ново, по-мащабно значение. В тази връзка, екипа на
          Zavedenia.bg се задължава да прилага и спазва всички правни
          разпоредби, свързани със защитата на лични данни. А именно:
        </p>
        <li>
          да съхранява и обработва данни, при изричното съгласие на
          собствениците на такива;
        </li>
        <li>да осигури защита на достъпа до тях от нежелани трети лица;</li>
        <li>да ги криптира и пази на собствен сървър;</li>
        <li>
          да не продава и/или предава лични данни към трети лица, без изричното
          съгласие на собствениците им и когато това не засяга основната дейност
          на Zavedenia.bg
        </li>
        <li>
          да не съхранява излишни лични данни, които по случайност или поради
          еднократни услуги са били налични към момента. Те се унищожават в
          рамките на 24 ч.
        </li>
        <li>
          да не нарушава други принципи относно правата на човека и да прилага
          успоредно всички закони, засягащи интересите на личността.
        </li>
        <br /><br />

        <b class="bold">Субекти на лични данни за Zavedenia.bg са:</b>
        <ul>
          <li>
            Регистрирани собственици (управители) на заведения (фирми);<br />
            а) Лични данни, които подлежат на съхранение и обработка от
            Zavedenia.bg: имена, телефонни номера, имейл адреси;<br />
            б) Лични данни, които собствениците (управителите) могат да изискат
            по всяко време: техните имена, техните телефонни номера, техните
            публикувани имейл адреси; Те имат достъп, опция за редакция, опция
            за изтриване и копиране на всички въведени от тях лични данни;
            <br />
            в) Лицата, субекти на лични данни могат да поискат сведения за трети
            лица, които имат достъп до техните лични данни.
          </li>
          <li>
            Регистрираните посетители на сайта.<br />
            а) Лични данни, които подлежат на съхранение и обработка от
            Zavedenia.bg: имена, телефонни номера, имейл адреси;<br />
            б) Лични данни, които посетителите могат да изискат по всяко време:
            техните имена, техните телефонни номера, техните публикувани имейл
            адреси; Те имат достъп, опция за редакция, опция за изтриване и
            копиране на всички въведени от тях лични данни; <br />
            в) Лицата, субекти на лични данни могат да поискат сведения за трети
            лица, които имат достъп до техните лични данни.
          </li>
        </ul>
        <p>
          Лични данни могат да бъдат събирани (и съхранявани) с цел
          осъществяване на основната дейност на Zavedenia.bg, в това число
          “онлайн резервация” на заведение. Zavedenia.bg пази информация относно
          кога, кой и във връзка с каква услуга е даличните му данни да бъдат
          обработвани от екипа. Тези данни или част от тях се пренасочват към
          извършване на допълнителна услуга само след изричното (повторно)
          съгласие на лицето-собственик.
        </p>
        <p>
          Данни като IP адреси, които могат да бъдат засечени, но не могат да
          бъдат свързани с конкретни лица или друга информация за тях НЕ се
          съхраняват от Zavedenia.bg и се класифицират като “анонимни” данни.
          Изключение се допуска, когато се установи злонамерена хакер или друга
          атака, идваща от определен IP адрес и трябва да се уведомят
          съответните органи.
        </p>
        При нарушаване съприкосновеността на съхраняваните лични данни от
        злонамерени трети лица или незаконното изземване на такива Zavedenia.bg
        ще уведоми компетентните органи (в случая КЗЛД) в рамките на 72 часа,
        както и пряко засегнатите лица, собственици на тези данни. Изключение от
        това правило се допуска, когато компетентни държавни органи изискат
        базата лични данни с цел разкриване на престъпление или друг правен
        акт.<br /><br />

        <b class="bold">ОТ ”ЗАКОН ЗА ЗАЩИТА НА ЛИЧНИТЕ ДАННИ”:</b>
        <p>
          <i>“Обработване на лични данни”</i> е всяко действие или съвкупност от
          действия, които могат да се извършат по отношение на личните данни с
          автомачни или други средства, като събиране, записване, организиране,
          съхраняване, адаптиране или изменение, възстановяване, консултиране,
          употреба, разкриване чрез предаване, разпространяване, предоставяне,
          актуализиране или комбиниране, блокиране, заличаване или унищожаване.
        </p>
        <p>
          <i>“Анонимни данни”</i> са лични данни, приведени във форма, която не
          позволява те да бъдат свързани със съответното физическо лице, за
          което се отнасят.
        </p>
        <p>
          <i>“Трето лице”</i> е физи§еско или юридическо лице, орган на държавна
          власт или на местно самоуправление, различен от физическото лице, за
          което се отнасят данните, от администратора на лични данни, от
          обработващия лични данни и от лицата, които под пряко ръководство на
          администратора или обработващия имат право да обработват лични данни.
        </p>
        <p>
          <i>“Съгласие на физическото лице”</i> е всяко свободно изразено,
          конкретно и информационно волеизявление, с което физическото лице, за
          което се отнасят личните данни, недвусмислено се съгласява те да бъдат
          обработвани.
        </p>

        <a name="cookies"></a>
        <h2>Използване на бисквитки (Cookies)</h2>

        <b class="bold">Термин "бисквитки" (Cookies)</b>
        <p>
          "Бисквитка" или "Cookies" представлява малък файл, който се изтегля на
          компютъра (устройството) ви, когато посещавате даден уеб сайт.
          Повечето уеб сайтове използват една или повече форми на "бисквитки".
          Тези файлове обикновено съдържат данни като името на сайта и
          <b class="bold">уникални и масови индентификатори</b>, с помощта на
          които се създава виртуален профил на потребителя. От тази гледна точка
          "бисквитките се третират като "лични данни" според GDPR и основно
          засягат онези идентификатори, използвани за анализи, реклама, както и
          тези, свързани с проведени чатове и разговори. Законът на ЕС за
          бисквитките се прилага за всички държави членки на съюза. Към
          настоящия момент всеки потребител има право да получи информираност за
          използваните бисквитки на посетения уеб сайт - да приеме или откаже
          прилагането им, давайки съгласие или несъгласие.
        </p>
        <p>
          Бисквитките обикновено са разделени на съществени и несъществени.
          Основните бисквитки са тези, които са необходими за предоставяне на
          информацията, поискана от потребителя и тяхното прилагане е
          необходимо, за да работи сайтът правилно. Всички други "бисквитки" се
          считат за несъществени - статистически, рекламни, част от
          функционалните. Според настройките на браузъра, вие може да разрешите
          или откажете съхранението на бисквитки от различни източници, да ги
          ограничите или да се приемат по подразбиране, може да ви се показва
          или не напомнящ прозорец при всяка нова "бисквитка".
        </p>
        <p>
          Сайтът zavedenia.bg (zavedenia.com) използва сесийни (данни се
          съхраняват само в периода на посещение на сайта и се изтриват при
          затваряне на браузъра) и постоянни (данни за посещения на сайта се
          съхраняват в браузъра, докато не бъдат изтрити собственоръчно от
          потребителя. В този случай при повторно посещение, сайтът разпознава
          потребителя като завърнал се) бисквитки, както и Facebook cookies и
          Youtube cookies.
        </p>

        <b class="bold">Защо използваме бисквитки и какви бисквитки позваме?</b>
        <p>
          Използваме бисквитки за да направим добър анализ на трафика на сайта и
          да оптимизираме съдържанието. Бисквитките са анономни, тоест
          <b class="bold">не свързваме</b> влизането Ви с каквито и да е
          персонални данни, като имена, домашен адрес, email или телефонен
          номер. Използваме бисквитки на Google Adsense и Facebook ( единствено
          в случаите когато ползвате "Вход чрез Facebook" в сайта ни).
        </p>

        <p>
          Информация за бисквитките на Facebook може да намерите
          <a href="https://www.facebook.com/policies/cookies/" target="_blank"
            >тук</a
          >.<br />

          Google analytics - като обработващ и съхраняващ данни, Google
          analytics е обект под контрола на GDPR. Google analytics е широко
          използван инструмент за анализ на трафика от Google, който позволява
          на собствениците на уебсайтове да получат цялостна и в реално време
          информация за начина, по който се използва сайта им, колко и от кого.
          За да придобиете представа каква информация колекционира Google може
          да прочетете тук:
          <a
            href="https://www.google.com/analytics/terms/us.html"
            target="_blank"
            >Google Analytics Policy</a
          >, както и тук:
          <a href="https://policies.google.com/privacy#infocollect"
            >Google Privacy Policy</a
          >. Давайки съгласие за активност на тази "бисквитка", вие разрешавате
          на посетения уебсайт, чрез инструмента Google analytics да събира
          информация Вас и да излъчва персонализирана реклама.
        </p>

        <b class="bold"
          >Всички те спомагат за конкретизиране на визуализираната информация
          пред различния потребител. Играят роля в препоръчките, анализите,
          проучванията, рекламата, сигурността и предлаганите услуги на
          сайта.</b
        ><br /><br />

        <b class="bold">Как може да изтрием бисквитки от Вашия браузер?</b>
        <p>
          Изтриването на бисквитки става от настойките на всеки един браузер.
          Бисквитки могат да бъдат изтрити изцяло от паметта на браузера или
          могат да бъдат избрани за изтриване само някои от тях. Например
          информация как може да изтриете бисквитки от Google Chrome може да
          намерите
          <a
            href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=bg"
            target="_blank"
            >тук</a
          >.<br />
          Ако ползвате Mozilla Firefox може да прочете как се изтриват бисквитки
          <a
            href="https://support.mozilla.org/bg/kb/%D0%9A%D0%B0%D0%BA%20%D0%B4%D0%B0%20%D0%B8%D0%B7%D1%82%D1%80%D0%B8%D0%B5%D0%BC%20%D0%BA%D0%B5%D1%88%D0%B0"
            target="_blank"
            >тук</a
          >, ако пък ползвате Internet Explorer
          <a
            href="https://support.microsoft.com/bg-bg/help/17442/windows-internet-explorer-delete-manage-cookies"
            >тук</a
          >. Винаги може да посетите и Google, за да откриете изчерпателна
          информация от много на брой сайтове как да триете бисквитки, дори ако
          нямате един от трите изброени браузера. Това може да направите
          <a
            href="https://www.google.bg/search?q=%D0%BA%D0%B0%D0%BA+%D0%B4%D0%B0+%D0%B8%D0%B7%D1%82%D1%80%D0%B8%D1%8F+%D0%B1%D0%B8%D1%81%D0%BA%D0%B2%D0%B8%D1%82%D0%BA%D0%B8%D1%82%D0%B5&rlz=1C5CHFA_enBG738BG738&oq=%D0%BA%D0%B0%D0%BA+%D0%B4%D0%B0+%D0%B8%D0%B7%D1%82%D1%80%D0%B8%D0%B5%D0%BC+%D0%B1%D0%B8%D1%81%D0%BA%D0%B2&aqs=chrome.1.69i57j0l5.8423j0j4&sourceid=chrome&ie=UTF-8"
            target="_blank"
            >тук</a
          >.
        </p>

        <b class="bold"
          >Каква информация събират услугите на трети юридически лица, като
          Facebook и Google?</b
        >
        <p>
          Производителност на сайта, анализ на посещенията - переодичност,
          дължина на посещението, географско положение (град/село).
        </p>
      </div>
      <div data-ng-if="language == 'mk'" *ngIf="selectedLang === 'mk'">
        <div class="agreements">
          За да ги користите услугите на веб-страницата, мора да се согласите со
          Општите услови за користење.
        </div>

        <h1>
          Општи услови за користење на услугата „резервирај“ преку
          веб-страницата или мобилната апликација на booky.mk
        </h1>

        <br />
        <p>
          <b class="bold"
            >I.„Резервирај“ е услуга на booky.mk, со која Вие се согласувате
            со следниве услови:</b
          >
        </p>
        <ul>
          <li>
            Да дадете точни информации за контакт – име, телефон, е-пошта.<br />
            (а) Информациите ќе се користат за повратен контакт по потреба;<br />
            (б) доколку внесете неточни или нецелосни податоци, Вашата
            резервација нема да биде валидна;<br />
            (в) ако веќе сте регистриран корисник на booky.mk, не е потребна
            нова регистрација. Со најавување во профилот, Вашите податоци ќе се
            користат за услугата „резервација на локал“ (врска до Општи услови
            за регистрација).
          </li>

          <li>
            Вашите податоци ќе бидат пренесени на локалот (трето лице), за кој
            правите резервација.<br />
            (а) Локалот има право да Ве контактира за дополнителни детали во
            врска со резервацијата;<br />
            (б) Локалот може да Ве контактира по реализирање на резервацијата за
            повратна информација;<br />
            (в) Локалот може да Ве потсети за претстојната резервација;
          </li>
        </ul>
        <p><b class="bold">II. Потврдување на резервации</b></p>
        <ul>
          <li>
            Вашата резервација е потврдена кога ќе добиете изречна потврда преку
            SMS, е-пошта или телефонски повик од локалот.
          </li>
          <li>
            Ако сакате да ја откажете резервацијата, сте должен/на да го
            известите локалот или да кликнете на линкот за откажување во
            е-поштата (доколку има таков линк).
          </li>
          <li>
            Ако не се појавите на направената резервација, може да бидете
            контактирани за утврдување на причините.
          </li>
        </ul>

        <p><b class="bold">III. Повратна информација </b></p>
        <ul>
          <li>
            Вашето мислење / повратна информација се испраќа до овластен
            претставник на локалот и не се објавува јавно, освен ако локалот не
            одлучи поинаку. Целта е да пријавите неправилност или да изразите
            благодарност.
          </li>
        </ul>

        <p><b class="bold">IV. Дополнителни одредби</b></p>
        <ol>
          <li>
            Терминот „резервирај“ може да се сретне и како „резервација“ или
            „направи резервација“. Во сите случаи станува збор за иста услуга.
          </li>
          <li>
            „Трето лице“ е локалот на кој испраќате резервација преку
            веб-страницата "http://booky.mk" или мобилната апликација.
          </li>
          <li>
            Тимот на booky.mk ги заштитува Вашите лични податоци согласно со
            Законот за заштита на лични податоци и нема право да ги предава на
            други, нерелевантни страни. Исто така, се обврзува да ги чува
            безбедно и да ги уништи по Ваше барање.
          </li>
        </ol>

        <p><b class="bold">V. Промена на условите и правилата</b></p>
        <ul>
          <li>
            booky.mk го задржува правото да ги измени правилата за обработка
            на резервации и податоци добиени преку нив.
          </li>
          <li>
            Сите промени ќе бидат објавени на оваа страница, и секој регистриран
            корисник ќе биде известен.
          </li>
        </ul>

        <br />
        <h1>Испраќање на SMS пораки во име на трето лице</h1>
        <p>
          Сопственици (менаџери) на локали имаат право да испраќаат SMS пораки
          до своите клиенти преку booky.mk, како корисници на SMS услуга.
          booky.mk тука има посредничка функција.
        </p>
        <p>
          Ова не е директна услуга од основната дејност на booky.mk и
          booky.mk не сноси одговорност за обработка и бришење на овие
          податоци. Одговорноста е на сопствениците на локалите.
        </p>
        <p>
          Дадените информации се ограничени само на телефонски броеви, без имиња
          или други лични податоци.
        </p>
        <p>
          Сопствениците (менаџерите) се согласуваат секој промотивен SMS да
          содржи опција за одбивање од страна на клиентот преку испраќање SMS со
          текст „STOP“. Телефонскиот број потоа ќе биде избришан од базата на
          податоци.
        </p>
        <p>
          booky.mk не одговара за прекршување на овие услови или на било кои
          други правни регулативи за заштита на личните податоци.
        </p>

        <br />
        <h1>
          Вашите лични податоци на booky.mk (накратко) <br />
          Зошто ги бараме?
        </h1>
        <ul>
          <li>
            <b class="bold">Кои податоци ги бараме?</b><br />За да направите
            резервација, потребни се <b class="bold">име, телефон и е-пошта</b>.
            Без телефон и е-пошта, резервацијата може да не биде прифатена.
          </li>
          <li>
            <b class="bold">Пристап на трето лице</b><br />Податоците се даваат
            на локалот каде што правите резервација, обично на вработен задолжен
            за резервации.
          </li>
          <li>
            <b class="bold">Период на чување</b><br />Податоците се чуваат 2
            години.
          </li>
        </ul>

        <h2>Кои се Вашите права?</h2>
        <ul>
          <li>
            <b class="bold">Право на пристап</b><br />Можете да побарате
            информации дали Вашите податоци се обработувани.
          </li>
          <li>
            <b class="bold">Право на бришење</b><br />Може да побарате бришење
            на податоците преку е-пошта на personaldata&#64;.bg со наслов
            „Бришење“.
          </li>
          <li>
            <b class="bold">Право на преносливост</b><br />Може да побарате
            податоци кога и зошто сме ги добиле. Испратете е-пошта со наслов
            „Извештај“.
          </li>
          <li>
            <b class="bold">Право на жалба</b><br />Може да се жалите до
            Агенцијата за заштита на личните податоци на
            <a href="https://www.cpdp.bg/?p=pages&aid=6">овој линк</a>.
          </li>
        </ul>

        <h2>Кои сме ние?</h2>
        <ul>
          <li>
            Сите веб-страници под booky.mk (zavedenia.com, booky.bg,
            programa.bg и лични страници на локали што ја користат платформата
            Booky.bg) се управувани од booky.mk ЕООД, со седиште во Софија.
          </li>
        </ul>

        <h2>Опсег на терминот „лични податоци“</h2>
        <p>
          Според GDPR, обработката, чувањето и бришењето на личните податоци
          добива ново значење. booky.mk се обврзува да:
        </p>
        <li>чува и обработува податоци само со експлицитна согласност;</li>
        <li>обезбеди заштита од неовластен пристап;</li>
        <li>ги чува на свој сервер, криптирани;</li>
        <li>не ги продава или предава без дозвола;</li>
        <li>не чува непотребни податоци, тие се бришат во рок од 24 часа;</li>
        <li>ги почитува човековите права и применува сите соодветни закони.</li>

        <br /><br />
        <b class="bold">Субјекти на лични податоци за booky.mk се:</b>
        <ul>
          <li>
            Регистрирани сопственици на локали;<br />
            а) Податоци што се чуваат: имиња, телефони, е-пошта;<br />
            б) Имаат пристап, можност за уредување, бришење и добивање
            копија;<br />
            в) Можат да побараат информации за трети лица кои имаат пристап до
            нивните податоци.
          </li>
          <li>
            Регистрирани посетители на веб-страницата;<br />
            а) Податоци: имиња, телефони, е-пошта;<br />
            б) Исто како и сопствениците, имаат сите горенаведени права;<br />
            в) Можат да побараат информации за трети лица кои имаат пристап до
            нивните податоци.
          </li>
        </ul>

        <p>
          Лични податоци може да се собираат со цел користење на услугата
          „онлајн резервација“. booky.mk чува информации за тоа кога, кој и
          за која услуга дал согласност.
        </p>
        <p>
          IP адреси што не може да се поврзат со лице не се чуваат и се сметаат
          за „анонимни“. Исклучок е ако има хакерски напад и мора да се известат
          надлежните органи.
        </p>
        <p>
          При нарушување на безбедноста на податоците, booky.mk ќе ги
          извести органите и засегнатите лица во рок од 72 часа. Исклучок е ако
          државен орган ги побара со цел откривање на кривично дело.
        </p>

        <br /><br />
        <b class="bold">ОД „ЗАКОН ЗА ЗАШТИТА НА ЛИЧНИ ПОДАТОЦИ“:</b>
        <p>
          <i>„Обработка на лични податоци“</i> е секоја операција како собирање,
          чување, измена, користење, откривање, бришење и др.
        </p>
        <p>
          <i>„Анонимни податоци“</i> се податоци што не можат да се поврзат со
          одредено лице.
        </p>
        <p>
          <i>„Трето лице“</i> е секое лице што не е субјект, администратор или
          обработувач на податоци.
        </p>
        <p>
          <i>„Согласност на физичко лице“</i> е слободно изразена волја за
          обработка на податоците.
        </p>

        <a name="cookies"></a>
        <h2>Користење на колачиња (Cookies)</h2>
        <b class="bold">Термин „колачиња“ (Cookies)</b>
        <p>
          „Колаче“ е мал фајл што се симнува на Вашиот уред при посета на
          веб-страница. Обично содржи име на веб-страница и
          <b class="bold">уникатни идентификатори</b>. Затоа се сметаат за лични
          податоци според GDPR.
        </p>
      </div>
      <div data-ng-if="language == 'sr'" *ngIf="selectedLang === 'sr'">
        <div class="agreements">
          Da biste koristili usluge sajta, morate se složiti sa Opštim uslovima korišćenja
        </div>

        <h1>
          Opšti uslovi korišćenja usluge "napravi rezervaciju" putem sajta ili mobilne aplikacije booknow.rs
        </h1>

        <br />
        <p>
          <b class="bold">
            I. "Napravi rezervaciju" je usluga booknow.rs, pri čemu se Vi slažete sa sledećim uslovima:
          </b>
        </p>
        <ul>
          <li>
            Da pružite tačne kontakt podatke – ime, telefon, email.<br />
            (а) Podaci će se koristiti za kontakt u slučaju potrebe;<br />
            (б) Ako unesete netačne, pogrešne ili nepotpune podatke, Vaša rezervacija neće biti validna;<br />
            (в) Ako ste već registrovani korisnik booknow.rs, nije potrebno da se ponovo registrujete. Prijavom na svoj profil, Vaši podaci će se koristiti za “rezervaciju mesta” (link ka Opštim uslovima registracije posetioca)
          </li>

          <li>
            Vaši podaci biće prosleđeni lokalu (trećem licu) za koji pravite rezervaciju.<br />
            (а) Lokal ima pravo da Vas kontaktira radi preciziranja detalja vezanih za rezervaciju;<br />
            (б) Lokal može da Vas kontaktira radi povratne informacije nakon realizovane rezervacije i posete;<br />
            (в) Lokal može da Vas kontaktira kao podsetnik za predstojeću rezervaciju;
          </li>
        </ul>

        <p><b class="bold">II. Potvrđivanje rezervacija</b></p>
        <ul>
          <li>
            Vaša rezervacija se smatra potvrđenom kada dobijete eksplicitnu potvrdu putem SMS-a, emaila ili telefonskog poziva od lokala.
          </li>
          <li>
            Ako želite da otkažete rezervaciju, obavezni ste da obavestite lokal ili da kliknete na link za otkazivanje koji se nalazi u emailu koji ste primili (ako postoji takav link).
          </li>
          <li>
            Ako se ne pojavite na zakazanu rezervaciju, možemo Vas kontaktirati kako bismo saznali razlog.
          </li>
        </ul>

        <p><b class="bold">III. Povratne informacije</b></p>
        <ul>
          <li>
            Vaše mišljenje / povratna informacija se prosleđuje ovlašćenom predstavniku lokala i ne objavljuje se javno, osim ako lokal ne odluči drugačije. Cilj povratne informacije je da ukažete na nepravilnosti ili izrazite zahvalnost.
          </li>
        </ul>

        <p><b class="bold">IV. Dodatne odredbe</b></p>
        <ol>
          <li>
            Termin "napravi rezervaciju" može se koristiti i u sinonimnim oblicima kao što su "rezerviši", "rezervacije". U svim slučajevima reč je o istoj usluzi.
          </li>
          <li>
            "Treće lice" je lokal za koji ste poslali rezervaciju putem sajta "http://booknow.rs" ili mobilne aplikacije booknow.rs
          </li>
          <li>
            Tim booknow.rs brižljivo postupa sa Vašim ličnim podacima, u skladu sa Zakonom o zaštiti ličnih podataka i nema pravo da ih ustupa drugim licima koja nisu direktno povezana sa uslugom; kao i da ih čuva savesno i na Vaš zahtev ih uništi.
          </li>
        </ol>

        <p><b class="bold">V. Promene uslova i pravila</b></p>
        <ul>
          <li>
            booknow.rs zadržava pravo da menja pravila i uslove za obradu rezervacija i podataka dobijenih preko sajta ili aplikacije.
          </li>
          <li>
            Sve promene biće objavljene na ovoj stranici, a svi registrovani korisnici će biti obavešteni.
          </li>
        </ul>

        <br />
        <h1>Slanje SMS poruka u ime trećih lica</h1>
        <p>
          Vlasnici (menadžeri) lokala imaju pravo da šalju SMS poruke svojim klijentima preko profila na booknow.rs, koristeći uslugu SMS paketa treće firme. booknow.rs u ovom slučaju ima ulogu posrednika.
        </p>
        <p>
          Ovo nije direktna usluga booknow.rs i booknow.rs ne snosi odgovornost za čuvanje, obradu i brisanje podataka potrebnih za uslugu slanja SMS-a. Odgovornost je u potpunosti na vlasnicima (menadžerima) lokala.
        </p>
        Informacije koje pružaju ograničene su samo na brojeve telefona, bez imena ili drugih ličnih podataka koji potpadaju pod GDPR.
        <br />
        <p>
          Vlasnici (menadžeri) lokala su saglasni da svaki reklamni SMS mora da sadrži opciju za odjavu. Klijent može poslati SMS sa tekstom STOP, nakon čega će njegov broj biti izbrisan iz baze i više neće dobijati poruke.
        </p>
        <p>
          booknow.rs ne snosi odgovornost u slučaju kršenja ovih zahteva, kao ni drugih zakonskih propisa u vezi sa GDPR od strane vlasnika (menadžera) lokala.
        </p>

        <h1>Vaši lični podaci na sajtovima booknow.rs (ukratko)</h1>
        <ul>
          <li>
            <b class="bold">Koji podaci su nam potrebni?</b><br />
            Prilikom rezervacije traže se ime, telefon i email. Bez telefona i emaila rezervacija može biti odbijena. Lokal može pozvati korisnika radi dodatne provere ili potvrde. Možete uneti samo ime i telefon.
          </li>
          <li>
            <b class="bold">Pristup trećeg lica Vašim podacima</b><br />
            Podaci se prosleđuju lokalu, obično osobi zaduženoj za rezervacije.
          </li>
          <li>
            <b class="bold">Period čuvanja</b><br />
            Podaci o rezervacijama se čuvaju 2 godine.
          </li>
        </ul>

        <h2>Koja su Vaša prava?</h2>
        <ul>
          <li>
            <b class="bold">Pravo na pristup</b><br />
            Možete zatražiti informaciju da li su vaši podaci obrađeni i da li su još uvek u bazi.
          </li>
          <li>
            <b class="bold">Pravo na brisanje</b><br />
            Možete zatražiti brisanje podataka slanjem emaila na personaldata&#64;booknow.rs sa naslovom "Brisanje"
          </li>
          <li>
            <b class="bold">Pravo na prenosivost podataka</b><br />
            Možete zatražiti izvod o tome kada i kako su Vaši podaci obrađeni putem emaila sa naslovom "Izvod"
          </li>
          <li>
            <b class="bold">Pravo na žalbu</b><br />
            Možete se obratiti Komisiji za zaštitu podataka: <a href="https://www.cpdp.bg/?p=pages&aid=6">https://www.cpdp.bg/?p=pages&aid=6</a> ili slanjem pošte na adresu: Sofija 1592, bul. "Prof. Cvetan Lazarov" br. 2
          </li>
        </ul>

        <h2>Ko smo mi?</h2>
        <ul>
          <li>
            Svi sajtovi pod booknow.rs (zavedenia.com, booky.bg, programa.bg i personalizovani sajtovi lokala) upravljani su od strane booknow.rs DOO, registrovani u Sofiji, adresa: Mladost 1, blok 29A, ulaz 3. Kompanija sarađuje sa partnerima u sektoru.
          </li>
        </ul>

        <h2>Obuhvat termina “lični podaci”</h2>
        <p>
          Prema GDPR regulativi Evropskog parlamenta i saveta, na snazi od 25. maja 2018. godine, booknow.rs se obavezuje da primenjuje sve zakonske propise o zaštiti ličnih podataka:
        </p>
        <li>da obrađuje podatke samo uz izričitu saglasnost korisnika;</li>
        <li>da obezbedi zaštitu pristupa od neovlašćenih lica;</li>
        <li>da ih enkriptuje i čuva na sopstvenom serveru;</li>
        <li>da ih ne prodaje niti deli bez saglasnosti vlasnika;</li>
        <li>da uništi sve nepotrebne podatke u roku od 24h;</li>
        <li>da poštuje sve zakone koji štite ljudska prava.</li>

        <br /><br />
        <b class="bold">Subjekti ličnih podataka za booknow.rs su:</b>
        <ul>
          <li>
            Registrovani vlasnici (menadžeri) lokala;<br />
            а) Podaci: ime, telefon, email;<br />
            б) Vlasnici mogu u svakom trenutku zahtevati pristup, izmenu, brisanje ili kopiju svojih podataka;<br />
            в) Imaju pravo da saznaju ko ima pristup njihovim podacima.
          </li>
          <li>
            Registrovani posetioci sajta;<br />
            а) Podaci: ime, telefon, email;<br />
            б) Imaju pravo na pristup, izmenu, brisanje i kopiranje podataka;<br />
            в) Imaju pravo da saznaju ko ima pristup njihovim podacima.
          </li>
        </ul>
        <p>
          Podaci se prikupljaju za potrebe online rezervacija. booknow.rs čuva podatke o tome kada, ko i zbog koje usluge je dao saglasnost. Podaci se dalje koriste samo uz dodatnu saglasnost.
        </p>
        <p>
          IP adrese koje se ne mogu povezati sa osobom klasifikuju se kao “anonimni” podaci. U slučaju napada, mogu se čuvati i proslediti nadležnim organima.
        </p>
        <p>
          U slučaju kršenja zaštite podataka, booknow.rs će u roku od 72 sata obavestiti nadležne organe i korisnike, osim ako nije drugačije naloženo od strane vlasti.
        </p>

        <b class="bold">Iz “Zakona o zaštiti ličnih podataka”:</b>
        <p>
          <i>“Obrada ličnih podataka”</i> je svaka radnja koja se odnosi na lične podatke, kao što su: prikupljanje, skladištenje, korišćenje, deljenje, brisanje itd.
        </p>
        <p>
          <i>“Anonimni podaci”</i> su podaci koji ne mogu biti povezani sa konkretnom osobom.
        </p>
        <p>
          <i>“Treće lice”</i> je fizičko ili pravno lice, ili organ vlasti koji nije korisnik podataka.
        </p>
      </div>

    </div>
  </div>
</div>
